/* @flow */

// TODO: This line is not needed? import { LOCATION_CHANGE } from 'react-router-redux'
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';



// WEBPACK FOOTER //
// ./src/app/modules/router/action-types.js